export interface ManamindRuntimeConfig {
  readonly apiBaseUrl?: string;
  /** ZTrust Keycloak realm base URL (OIDC authority) -- Cognito removed. */
  readonly ztrustIssuerUrl?: string;
  /** Public OIDC client id registered with Keycloak for this SPA. */
  readonly ztrustClientId?: string;
}

declare global {
  interface Window {
    __MANAMIND_CONFIG__?: ManamindRuntimeConfig;
  }
}

export function getRuntimeConfig(): Required<ManamindRuntimeConfig> {
  const runtime = window.__MANAMIND_CONFIG__ ?? {};

  return {
    apiBaseUrl: runtime.apiBaseUrl ?? import.meta.env.VITE_API_URL ?? '/api/v1',
    ztrustIssuerUrl: runtime.ztrustIssuerUrl ?? import.meta.env.VITE_ZTRUST_ISSUER_URL ?? 'https://auth.gdna.io/realms/gdna',
    ztrustClientId: runtime.ztrustClientId ?? import.meta.env.VITE_ZTRUST_CLIENT_ID ?? 'gdna-manamind',
  };
}
